import Colors from "../../../../../global/Colors";
import HNSColors from "../../../../HNSColors";

export const TAB_STYLES = {
  TAB: {
    SX: {
      minHeight: 48,
      backgroundColor: Colors.white,
      borderRadius: "16px 16px 0 0",
      padding: "1rem 1rem 0.5rem 1rem",
      "& .MuiTab-root": {
        color: Colors.black,
        fontWeight: 700,
        minWidth: 120,
        minHeight: 48,
        textTransform: "capitalize",
        backgroundColor: Colors.gray[100],
        borderRadius: "8px",
        marginRight: "8px",
        padding: "0.5rem 1rem",
      },
      "& .MuiTab-root:last-of-type": {
        marginRight: 0,
      },
      "& .Mui-selected": {
        color: HNSColors.primary[500],
        backgroundColor: HNSColors.tertiary[900],
      },
      "& .Mui-disabled": {
        color: HNSColors.neutrals[700],
      },
    },
    TAB_INDICATOR_SX: { backgroundColor: "transparent" },
  },
  SUB_TAB: {
    SX: {
      minHeight: 48,
      backgroundColor: HNSColors.tertiary[900],
      borderRadius: "8px",
      margin: "0 1rem",
      "& .MuiTab-root": {
        color: HNSColors.primary[500],
        fontWeight: 500,
        minWidth: 120,
        minHeight: 48,
        borderBottom: "none",
        textTransform: "capitalize",
        padding: "0 0.5rem",
      },
      "& .Mui-selected": {
        color: HNSColors.primary[500],
        fontWeight: 700,
        borderBottom: `4px solid ${HNSColors.primary[500]}`,
        backgroundColor: "transparent",
      },
      "& .Mui-disabled": {
        color: HNSColors.neutrals[700],
      },
    },
    TAB_INDICATOR_SX: { backgroundColor: "transparent" },
  },
};
